import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface IAlertDialogProps {
    handleClose: () => void;
    open: boolean;
    children?: string;
    title?: string;
    actions?: {
        title: string;
        handler: () => void;
        color: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
        autofocus: boolean;
    }[];
}

export const AlertDialog = ({ handleClose, open, children, title, actions = [] }: IAlertDialogProps) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby={`alert-dialog-${title.toLowerCase()}`}
            aria-describedby={`alert-dialog-${children.toLowerCase()}`}
        >
            <DialogTitle id={`alert-dialog-${title.toLowerCase()}`}>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id={`alert-dialog-${children.toLowerCase()}`}>{children}</DialogContentText>
            </DialogContent>
            <DialogActions>
                {actions.map(act => (
                    <Button onClick={act.handler} color={act.color} autoFocus={act.autofocus} key={act.title}>
                        {act.title}
                    </Button>
                ))}
            </DialogActions>
        </Dialog>
    );
};
